import { fromJS } from "immutable";
import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listFiltered: [],
  isFetching: false,
  isFetchingFilter: false,
});

export default function auditLogReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_LOADING:
      return state.merge({ isFetching: true });

    case TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_LOADING:
      return state.merge({ isFetchingFilter: true });

    case TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_FAILURE:
      return state.merge({ isFetching: false });

    case TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_FAILURE:
      return state.merge({ isFetchingFilter: false });

    case TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_SUCCESS:
      return state.merge({
        isFetching: false,
        list: action.payload || [],
      });

    case TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_SUCCESS:
      return state.merge({
        isFetchingFilter: false,
        listFiltered: action.payload || [],
      });

    default:
      return state;
  }
}

